import React, { createContext, useContext, useState, ReactNode } from 'react';
import { DateRange } from '../components/Common/DateRangePicker';

interface DateRangeContextType {
  dateRange: DateRange;
  setDateRange: (range: DateRange) => void;
}

const DateRangeContext = createContext<DateRangeContextType | undefined>(undefined);

export function DateRangeProvider({ children }: { children: ReactNode }) {
  const [dateRange, setDateRange] = useState<DateRange>(() => {
    // Default to last 30 days
    const today = new Date();
    const last30Days = new Date(today);
    last30Days.setDate(today.getDate() - 29);
    last30Days.setHours(0, 0, 0, 0);
    today.setHours(23, 59, 59, 999);
    return { startDate: last30Days, endDate: today };
  });

  return (
    <DateRangeContext.Provider value={{ dateRange, setDateRange }}>
      {children}
    </DateRangeContext.Provider>
  );
}

export function useDateRange() {
  const context = useContext(DateRangeContext);
  if (!context) {
    throw new Error('useDateRange must be used within DateRangeProvider');
  }
  return context;
}
